import {
  locationIdFormat,
  processingSessionIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";
import { ProcessingSession_ } from "./processing-session";

export const completeProcessingSession = {
  name: "completeProcessingSession" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    locationId: locationIdFormat.schema.optional(),
    // Identifies the operator's station so completion can attribute the return
    // to its open station session and route units into bound totes. Optional:
    // absent falls back to single-open-session-at-location detection.
    workstationId: z.string().optional(),
  }),
  output: z.object({ session: ProcessingSession_ }),
};
